var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React, { PureComponent } from "react";
import qs from "qs";
import identityService from "@irati/identity/services/users";
import onboardingService from "@irati/onboarding/services/onboarding";
import API from "@irati/utils/services/API";
import internalLoginService from "@irati/auth/services/internalLogin";
// import {getTenantTokenForGhost} from "@irati/auth/services/ghostUserLogin"
import loginService from "@irati/auth/services/login";
import { setLoginChallengePassword } from "@irati/auth/services/password";
import OnboardingStep from "@irati/onboarding/enums/Step";
import tenantService from "@irati/identity/services/tenant";
import switchboardService from "@irati/permissions/services/switchboard";
import generateNewTenant from "./generateNewTenant";
import generateNewUsers from "./generateNewUsers";
import { READY, SENDING_ENV, RUNNING_SCRIPT, SUCCESS, ERROR } from "../constants/status";
var CreateTestTenantAndUsers = /** @class */ (function (_super) {
    __extends(CreateTestTenantAndUsers, _super);
    function CreateTestTenantAndUsers() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onReceiveMessage = function (_a) {
            var data = _a.data;
            if (data) {
                if (data && data.status === SENDING_ENV) {
                    _this.createTestTenantAndUsers(data.data);
                    var message = {
                        status: RUNNING_SCRIPT
                    };
                    window.postMessage(message, "*");
                }
            }
        };
        _this.createTestTenantAndUsers = function (_a) {
            var internalAdminId = _a.internalAdminId, internalAdminPassword = _a.internalAdminPassword, jobId = _a.jobId;
            return __awaiter(_this, void 0, void 0, function () {
                var tenant, internalAdminUser, internalAdminAccessToken_1, newTenantDetails, newTenant, tenantId_1, basePermission, dealPackage, newUsersDetails, newUsers, message, e_1, message;
                var _this = this;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            _b.trys.push([0, 12, , 13]);
                            tenant = "e2e-tenant-" + jobId;
                            return [4 /*yield*/, internalLoginService.login(internalAdminId, internalAdminPassword)];
                        case 1:
                            internalAdminUser = _b.sent();
                            internalAdminAccessToken_1 = internalAdminUser.accessToken;
                            API.setTokens(internalAdminAccessToken_1);
                            newTenantDetails = generateNewTenant(tenant);
                            return [4 /*yield*/, tenantService.createTenant(newTenantDetails)];
                        case 2:
                            newTenant = _b.sent();
                            tenantId_1 = newTenant.uuid;
                            basePermission = {
                                tenantId: tenantId_1,
                                teamId: null,
                                values: []
                            };
                            dealPackage = {
                                tenantId: tenantId_1,
                                teamId: null,
                                values: ["89559259-15cc-437f-b4d2-b80578a6190e"]
                            };
                            return [4 /*yield*/, switchboardService.update(__assign(__assign({}, basePermission), { action: "ENABLE_PRODUCT_DEALS" }))];
                        case 3:
                            _b.sent();
                            return [4 /*yield*/, switchboardService.update(__assign(__assign({}, basePermission), { action: "DEALS_ENABLE_CARDLINKED" }))];
                        case 4:
                            _b.sent();
                            return [4 /*yield*/, switchboardService.update(__assign(__assign({}, dealPackage), { action: "SET_PACKAGE" }))];
                        case 5:
                            _b.sent();
                            return [4 /*yield*/, switchboardService.update(__assign(__assign({}, basePermission), { action: "ENABLE_PRODUCT_RECOGNITION" }))];
                        case 6:
                            _b.sent();
                            return [4 /*yield*/, switchboardService.update(__assign(__assign({}, basePermission), { action: "ENABLE_PRODUCT_TENANT_WALLET" }))];
                        case 7:
                            _b.sent();
                            return [4 /*yield*/, switchboardService.update(__assign(__assign({}, basePermission), { action: "ENABLE_PRODUCT_USER_WALLET" }))];
                        case 8:
                            _b.sent();
                            return [4 /*yield*/, switchboardService.update(__assign(__assign({}, basePermission), { action: "ENABLE_PRODUCT_INSIGHTS" }))];
                        case 9:
                            _b.sent();
                            return [4 /*yield*/, switchboardService.update(__assign(__assign({}, basePermission), { action: "ENABLE_PRODUCT_MEDICAL" }))
                                // Log into tenant with ghost user
                                // const ghostUserToken = await getTenantTokenForGhost(tenantId)
                                // API.setTokens(ghostUserToken)
                                // Create new users
                            ];
                        case 10:
                            _b.sent();
                            newUsersDetails = generateNewUsers(jobId, tenantId_1);
                            return [4 /*yield*/, Promise.all(newUsersDetails.map(function (newUserDetails) { return _this.createUser(newUserDetails, internalAdminAccessToken_1, tenantId_1); }))];
                        case 11:
                            newUsers = _b.sent();
                            message = {
                                status: SUCCESS,
                                newTenant: newTenant,
                                newUsers: newUsers
                            };
                            window.postMessage(message, "*");
                            return [3 /*break*/, 13];
                        case 12:
                            e_1 = _b.sent();
                            console.log("Create tenant and user error", e_1);
                            message = {
                                status: ERROR,
                                error: e_1
                            };
                            window.postMessage(message, "*");
                            return [3 /*break*/, 13];
                        case 13: return [2 /*return*/];
                    }
                });
            });
        };
        _this.createUser = function (newUser, internalAdminAccessToken, tenantId) { return __awaiter(_this, void 0, void 0, function () {
            var newUserPassword_1, createdUser_1, onboardingUrl, tmp, tenantObj_1, e_2;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 4, , 5]);
                        newUserPassword_1 = "Huddlebuy1";
                        return [4 /*yield*/, identityService.createIdentity(newUser, newUser.role)];
                    case 1:
                        createdUser_1 = _a.sent();
                        return [4 /*yield*/, onboardingService.getOnboardingUrl(createdUser_1.uuid, internalAdminAccessToken)];
                    case 2:
                        onboardingUrl = (_a.sent()).onboardingUrl;
                        tmp = qs.parse(onboardingUrl).tmp;
                        tenantObj_1 = { uuid: tenantId };
                        return [4 /*yield*/, loginService.login(tenantObj_1, newUser.email, tmp).catch(function (err) { return __awaiter(_this, void 0, void 0, function () {
                                var response, loginAttemptTwo;
                                return __generator(this, function (_a) {
                                    switch (_a.label) {
                                        case 0:
                                            response = err.apiError.response;
                                            return [4 /*yield*/, setLoginChallengePassword(newUserPassword_1, response.data.data)];
                                        case 1:
                                            _a.sent();
                                            return [4 /*yield*/, loginService.login(tenantObj_1, newUser.email, newUserPassword_1)];
                                        case 2:
                                            loginAttemptTwo = _a.sent();
                                            return [4 /*yield*/, onboardingService.completeStep(createdUser_1, OnboardingStep.ACCEPT_GDPR, loginAttemptTwo.accessToken)];
                                        case 3:
                                            _a.sent();
                                            return [2 /*return*/, loginAttemptTwo];
                                    }
                                });
                            }); })];
                    case 3: return [2 /*return*/, _a.sent()];
                    case 4:
                        e_2 = _a.sent();
                        console.log("Create User Error", e_2);
                        return [2 /*return*/, null];
                    case 5: return [2 /*return*/];
                }
            });
        }); };
        return _this;
    }
    CreateTestTenantAndUsers.prototype.componentDidMount = function () {
        window.addEventListener("message", this.onReceiveMessage);
        var message = {
            status: READY
        };
        window.postMessage(message, "*");
    };
    CreateTestTenantAndUsers.prototype.componentWillUnmount = function () {
        window.removeEventListener("message", this.onReceiveMessage);
    };
    CreateTestTenantAndUsers.prototype.render = function () {
        return React.createElement("h2", null, "Create test tenant and users for E2E");
    };
    return CreateTestTenantAndUsers;
}(PureComponent));
export default CreateTestTenantAndUsers;
